import {
  globalConstants,
  privacyPolicyConstants,
  termsAndConditionsConstants,
} from "../../constants";
import { ERROR_TOAST, SUCCESS_TOAST } from "../../constants/toast.constants";
import { termsAndConditionsService } from "../../services";
import { customToast } from "../../shared/utility";
import { custom, success } from "./utilities";

const { ADD_OR_UPDATE_TERMS_AND_CONDITIONS, GET_TERMS_AND_CONDITIONS } =
  termsAndConditionsConstants;

const addOrUpdateTermsAndConditions = (data, successFunc) => (dispatch) => {
  dispatch(
    custom(ADD_OR_UPDATE_TERMS_AND_CONDITIONS, globalConstants.SPINNER_ACTIVATE)
  );
  termsAndConditionsService
    .addOrUpdateTermsAndConditions(data)
    .then(
      (response) => {
        customToast(response.msg, SUCCESS_TOAST);
        successFunc();
      },
      (error) => customToast(error[1], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(
        custom(ADD_OR_UPDATE_TERMS_AND_CONDITIONS, globalConstants.SPINNER_DIACTIVATE)
      )
    );
};

const getTermsAndConditions = () => (dispatch) => {
  dispatch(custom(GET_TERMS_AND_CONDITIONS, globalConstants.SPINNER_ACTIVATE));
  termsAndConditionsService
    .getTermsAndConditions()
    .then(
      (response) => dispatch(success(response, GET_TERMS_AND_CONDITIONS)),
      (error) => customToast(error[1], ERROR_TOAST)
    )
    .finally(() =>
      dispatch(custom(GET_TERMS_AND_CONDITIONS, globalConstants.SPINNER_DIACTIVATE))
    );
};

export const termsAndConditionsActions = {
  addOrUpdateTermsAndConditions,
  getTermsAndConditions,
};
